var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _c('form-component', {
    ref: "specimenForm",
    attrs: {
      "formData": _vm.formData
    },
    scopedSlots: _vm._u([{
      key: "additional-info-section",
      fn: function () {
        return [_c('div', {
          staticClass: "specimen-info-container"
        }, [_c('label', {
          staticClass: "specimen-info-label"
        }, [_vm._v(" Specimen Additional Info (If Applicable) ")]), _vm.caughtInfoValues.length ? _c('nested-question', {
          attrs: {
            "display": 'main',
            "questionsMetadata": {
              questionRawList: _vm.questionsMetadata.questionRawList,
              questionList: _vm.questionsMetadata.questionList,
              widgets: _vm.questionsMetadata.widgets,
              parentWidget: _vm.questionsMetadata.widgets,
              catchValue: _vm.questionsMetadata.catchValue
            }
          }
        }) : _vm._e(), _c('v-btn', {
          staticClass: "add-info-button",
          attrs: {
            "color": "primary",
            "dark": "",
            "block": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.onClickAddInfo();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" Add Specimen info ")], 1)], 1)];
      },
      proxy: true
    }, {
      key: "protocol-number-section",
      fn: function () {
        return [_c('v-card', {
          staticClass: "mx-auto"
        }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.protocolNumberTableMetadata.title) + " "), _c('v-spacer'), _c('v-btn', {
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "dark": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.onClickShowProtocolNumberSelection();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.protocolNumberTableMetadata.addButtonName) + " ")], 1)], 1), _c('v-card-text', [_vm._l(_vm.warning, function (message, index) {
          return _c('v-alert', {
            key: ("warning" + index),
            attrs: {
              "type": "error"
            }
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(message)
            }
          })]);
        }), _c('ul', {
          staticStyle: {
            "list-style-type": "none",
            "margin": "0px",
            "padding": "0px"
          }
        }, [_c('draggable', {
          attrs: {
            "handle": ".handle",
            "list": _vm.protocolNumberTableMetadata.items
          }
        }, _vm._l(_vm.protocolNumberTableMetadata.items, function (item, index) {
          return _c('li', {
            key: ("pn" + index)
          }, [_c('v-btn', {
            staticClass: "handle",
            attrs: {
              "text": ""
            }
          }, [_c('v-icon', [_vm._v("mdi-menu")])], 1), _c('span', {
            staticClass: "text"
          }, [_vm._v(_vm._s(item.protocolNumber))]), _c('v-btn', {
            staticClass: "close",
            attrs: {
              "text": ""
            }
          }, [_c('v-icon', {
            staticClass: "mr-2",
            attrs: {
              "color": "primary"
            },
            on: {
              "click": function ($event) {
                return _vm.onClickDelete(item);
              }
            }
          }, [_vm._v(" mdi-delete ")])], 1)], 1);
        }), 0)], 1)], 2)], 1)];
      },
      proxy: true
    }, {
      key: "save-button-section",
      fn: function () {
        return [_c('v-btn', {
          staticStyle: {
            "margin-top": "20px"
          },
          attrs: {
            "color": "primary",
            "depressed": "",
            "clearable": "",
            "type": "button",
            "disabled": _vm.disableSubmitBtn
          },
          on: {
            "click": function ($event) {
              return _vm.onClickSpecimenSave();
            }
          }
        }, [_vm._v(" Save ")])];
      },
      proxy: true
    }])
  }), _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "right": "",
      "temporary": "",
      "width": "650px"
    },
    model: {
      value: _vm.isSelectingProtocolNumbers,
      callback: function ($$v) {
        _vm.isSelectingProtocolNumbers = $$v;
      },
      expression: "isSelectingProtocolNumbers"
    }
  }, [_c('v-list-item', [_c('h3', [_vm._v(_vm._s(_vm.navDrawerSelectionMetadata.protocolNumber.title))])]), _c('v-divider'), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.navDrawerSelectionMetadata.protocolNumber.tableTitle) + " "), _c('v-spacer'), _c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: _vm.navDrawerSelectionMetadata.protocolNumber.search,
      callback: function ($$v) {
        _vm.$set(_vm.navDrawerSelectionMetadata.protocolNumber, "search", $$v);
      },
      expression: "navDrawerSelectionMetadata.protocolNumber.search"
    }
  })], 1), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.navDrawerSelectionMetadata.protocolNumber.headers,
      "items": _vm.navDrawerSelectionMetadata.protocolNumber.items,
      "items-per-page": 5,
      "search": _vm.navDrawerSelectionMetadata.protocolNumber.search,
      "item-key": "_id",
      "show-select": "",
      "single-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "color": "blue"
          },
          on: {
            "click": function ($event) {
              return _vm.onClickViewFormPreview(item);
            }
          }
        }, [_vm._v(" mdi-eye ")])];
      }
    }], null, true),
    model: {
      value: _vm.navDrawerSelectionMetadata.protocolNumber.selected,
      callback: function ($$v) {
        _vm.$set(_vm.navDrawerSelectionMetadata.protocolNumber, "selected", $$v);
      },
      expression: "navDrawerSelectionMetadata.protocolNumber.selected"
    }
  })], 1), _c('v-btn', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.onClickAddSelectedProtocolNumberItems
    }
  }, [_vm._v(" Add ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }